import React, { useState, useEffect } from "react";
import { Button, Modal, Tooltip } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, message, Space } from "antd";
import Populate from "./populate";
import axios from "axios";
import Layout from "./analyze";
import backimage from "../../assets/icons/prev.svg";
import chevron from "../../assets/icons/cheveron.svg";
import linked from "../../assets/icons/linked.svg";
import add from "../../assets/icons/add-2.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
const ScannedStatus = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState();
  const [showValues, setShowValues] = useState(null);
  const [currentlySelectedRoom, setCurrentlySelectedRoom] = useState(false);
  const [nestedClasses, setNestedClasses] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [currentlySelectedItem, setCurrentlySelectedItem] = useState(false);
  const [textData, setTextData] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [selectedRoomForTooltip, setSelectedRoomForTooltip] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { file } = location.state;

  const handleClick = () => {
    if (data) {
      navigate("/populate", { state: { data, nestedClasses } });
    }
  };

  const validateSpaces = () => {
    if (data) {
      toast.success("Rooms validated successfully");
    } else {
      toast.error("No Rooms to validate");
    }
  };

  const validateItems = () => {
    if (data) {
      toast.success("Items validated successfully");
    } else {
      toast.error("No Items to validate");
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const isInside = (box1, box2) => {
    return (
      box1.x >= box2.x &&
      box1.y >= box2.y &&
      box1.x + box1.width <= box2.x + box2.width &&
      box1.y + box1.height <= box2.y + box2.height
    );
  };

  const allowedRoomTypes = [
    "Living Room",
    "Bedroom",
    "room",
    "kitchen",
    "garage",
    "Bathroom",
    "Balcony",
    "staircase",
    "Wardrobe",
    "DiningRoom",
    "Staircase",
    "Master Bedroom",
    "office",
    "StoreRoom",
    "Utility",
    "PrayerRoom",
    "BalconyRailing",
    "StudyRoom",
    "Office",
    "space",
  ];

  useEffect(() => {
    if (Array.isArray(data)) {
      const nested = findNestedClasses(
        data?.map((item) => ({
          ...item,
          x: item.x - item.width / 2,
          y: item.y - item.height / 2,
          type: item.class,
        }))
      );
      setNestedClasses(nested);
    }
  }, [data]);

  const findNestedClasses = (elements) => {
    const relationships = [];
    const roomWallsMap = {};

    elements.forEach((element, index) => {
      if (element.class === "Walls") {
        const associatedRoom = elements.find(
          (room) => room.index === element.roomIndex
        );
        if (associatedRoom) {
          roomWallsMap[index] = associatedRoom;
        }
      }
    });

    elements.forEach((outer, index1) => {
      if (allowedRoomTypes.includes(outer.class)) {
        const containedClasses = [];
        elements.forEach((inner, index2) => {
          if (index1 !== index2 && isInside(inner, outer)) {
            if (
              inner.x >= outer.x &&
              inner.y >= outer.y &&
              inner.x + inner.width <= outer.x + outer.width &&
              inner.y + inner.height <= outer.y + outer.height
            ) {
              if (inner.class === "Walls") {
                const associatedRoom = roomWallsMap[index2];
                if (associatedRoom) {
                  containedClasses.push({
                    index: index2,
                    class: associatedRoom.class,
                    x: inner.x,
                    y: inner.y,
                    width: inner.width,
                    height: inner.height,
                  });
                }
              } else {
                containedClasses.push({
                  index: index2,
                  class: inner.class,
                  x: inner.x,
                  y: inner.y,
                  width: inner.width,
                  height: inner.height,
                });
              }
            }
          }
        });

        relationships.push({
          x: outer.x,
          y: outer.y,
          width: outer.width,
          height: outer.height,
          index: index1,
          class: outer.class,
          contains: containedClasses,
        });
      }
    });

    return relationships;
  };

  const handleRoomClick = (room) => {
    if (currentlySelectedRoom && currentlySelectedRoom.index === room.index) {
      setCurrentlySelectedRoom(false);
    } else {
      setCurrentlySelectedRoom(room);
      setCurrentlySelectedItem(false);
    }
  };

  const handleItemClick = (item) => {
    if (currentlySelectedItem && currentlySelectedItem.index === item.index) {
      setCurrentlySelectedItem(false);
    } else {
      setCurrentlySelectedItem(item);
    }
  };

  const analyze = async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const formData2 = new FormData();
      formData2.append("image_file", file);

      if (selectedOption === "labeled") {
        setIsloading(true);
        const response = await axios.post(
          "https://sync.octalooptechnologies.com/all-in-one/",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        const textResponse = await axios.post(
          "https://sync.octalooptechnologies.com/extract-text/",
          formData2,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        // console.log("response", response);
        // console.log("textResponse", textResponse);
        setData(response.data);
        setTextData(textResponse.data.extracted_text);
        setIsloading(false);

        const nested = findNestedClasses(
          response.data.map((item) => ({
            ...item,
            x: item.x - item.width / 2,
            y: item.y - item.height / 2,
            type: item.class,
          }))
        );
        setNestedClasses(nested);
      } else if (selectedOption === "empty") {
        setIsloading(true);
        const response = await axios.post(
          "https://sync.octalooptechnologies.com/no-label-model/",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        const textResponse = await axios.post(
          "https://sync.octalooptechnologies.com/extract-text/",
          formData2,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        setData(response.data);
        setTextData(textResponse.data.extracted_text);
        setIsloading(false);

        const nested = findNestedClasses(
          response.data.map((item) => ({
            ...item,
            x: item.x - item.width / 2,
            y: item.y - item.height / 2,
            type: item.class,
          }))
        );
        setNestedClasses(nested);
      } else {
        toast.error("Select Floorplan type");
      }
    } catch (error) {
      toast.error("Error:", error);
      setIsloading(false);
    }
  };

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const selectedRoomItems = currentlySelectedRoom
    ? nestedClasses
        .find((room) => room.index === currentlySelectedRoom.index)
        ?.contains.filter(
          (item) => !["Walls", "window", "door"].includes(item.class)
        )
        .map((room) => {
          let found = data.find(
            (item) =>
              item.class == room.class &&
              Number(Math.round(item.x - item.width / 2)) ==
                Number(Math.round(room.x)) &&
              Number(Math.round(item.y - item.height / 2)) ==
                Number(Math.round(room.y)) &&
              item.width == room.width &&
              item.height == room.height
          );

          if (found != undefined) {
            return found;
          } else {
            return {};
          }
        }) || []
    : [];

  const imageUrl = URL.createObjectURL(file);
  const roomNames = textData?.split("\n");
  const items = [
    {
      label: "Bedroom",
      key: "0",
    },
    {
      label: "Livingroom",
      key: "1",
    },
    {
      label: "Kitchen",
      key: "2",
    },
    {
      label: "Dressing",
      key: "3",
    },
    {
      label: "Others",
      key: "4",
    },
  ];
  const handleTooltipClick = (room) => {
    setSelectedRoomForTooltip(room);
  };

  const handleListItemClick = (newClassName) => {
    if (selectedRoomForTooltip) {
      setNestedClasses((prev) =>
        prev.map((room) =>
          room.index === selectedRoomForTooltip.index
            ? { ...room, class: newClassName }
            : room
        )
      );
      // setSelectedRoomForTooltip(null);
    }
  };

  const abc = (
    <>
      <div className="drop-wrapper">
        <label>Verify Spaces</label>
        {roomNames ? (
          roomNames.map((roomName, index) => (
            <li key={index} onClick={() => handleListItemClick(roomName)}>
              {roomName}
            </li>
          ))
        ) : (
          <li>Loading...</li>
        )}
      </div>
    </>
  );

  return (
    <div>
      <div className="parent-wrapper">
        <div className="button-container">
          <img
            src={backimage}
            className="back-image-styles d-none"
            onClick={() => navigate(-1)}
          />{" "}
          <img
            src={backimage}
            className="back-image-styles"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="floor-1">
          <div className="floor-left d-flex flex-column align-items-center">
            <div className=" floor-left d-flex">
              <h1>{file.name}</h1>
              <img src="/assets/icons/edit.svg" alt="" />
            </div>
            <div className="floor-left-content">
              {data && data.length > 0 ? (
                <div className="retry cursor-pointer">
                  <img src="/assets/icons/retry.svg" alt="" />
                  <p className="medium fw-normal">Retry</p>
                </div>
              ) : (
                <div
                  className="retry cursor-pointer"
                  style={{ visibility: "hidden" }}
                >
                  <img src="/assets/icons/retry.svg" alt="" />
                  <p className="medium fw-normal">Retry</p>
                </div>
              )}
              {data && data.length > 0 ? (
                <Layout
                  file={file}
                  selectedRoom={currentlySelectedRoom}
                  data={data}
                  nestedClasses={nestedClasses}
                  selectedItem={currentlySelectedItem}
                  setData={setData}
                />
              ) : (
                <div className="canvas d-flex flex-column justify-content-center align-items-center position-relative">
                  <img
                    src={imageUrl}
                    alt=""
                    className={`img-fluid  ${
                      isloading ? "opacity-25" : "opacity-1"
                    }`}
                  />
                  <button
                    onClick={analyze}
                    disabled={isloading ? "disabled" : ""}
                  >
                    Analyze
                  </button>
                  {isloading && (
                    <div className="loader-div position-absolute">
                      <div className="loader-container">
                        <div class="loader">asdasd</div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="floor-right d-flex flex-column align-items-center">
            {/* selec plan & add floor btns */}
            <div className="d-flex gap-2">
              <select className="add-floor" onChange={handleSelectChange}>
                <option selected disabled>
                  Select floorplan type
                </option>
                <option value="labeled">Labeled Floorplan</option>
                <option value="empty">Empty Floorplan</option>
              </select>
              <button onClick={() => navigate(-1)} className="add-floor">
                + Add Floor
              </button>
            </div>

            {/* roooms */}
            <div className="room-and-items">
              <div className="room">
                <h6 className="pb-4 text-center">ROOM</h6>
                <div className="room-inner w-100">
                  {nestedClasses.map((room) => (
                    <div key={room.index} className="bedroom">
                      <p
                        className="pointer"
                        onClick={() => handleRoomClick(room)}
                      >
                        {room.class.substring(0, 17)}
                      </p>
                      <div className="d-flex gap-3">
                        <img
                          src="/assets/icons/delete.svg"
                          alt=""
                          className="pointer"
                        />
                        <Tooltip
                          trigger="click"
                          placement="right"
                          title={abc}
                          onOpenChange={() => handleTooltipClick(room)}
                        >
                          <img src={chevron} alt="" className="pointer" />
                        </Tooltip>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="buttons">
                  <div className="edit-button">
                    <img src="/assets/icons/edit2.svg" alt="" />
                  </div>
                  <div className="validate">
                    <button onClick={validateSpaces}>Validate Spaces</button>
                  </div>
                </div>
              </div>
              <div className="items">
                <h6 className="pb-4 text-center">ITEMS</h6>
                <div className="item-scroll">
                  {currentlySelectedRoom
                    ? selectedRoomItems.map(
                        (item) =>
                          item.class && (
                            <div
                              key={item.index}
                              style={{ cursor: "pointer" }}
                              className="bedroom"
                              onClick={() => handleItemClick(item)}
                            >
                              <p>{item.class}</p>
                              <img src="/assets/icons/delete.svg" alt="" />
                            </div>
                          )
                      )
                    : data &&
                      data.map((item, index) => {
                        if (
                          ![
                            "Walls",
                            "window",
                            "door",
                            "space",
                            ...allowedRoomTypes,
                          ].includes(item.class)
                        ) {
                          return (
                            <div className="even-purple" key={index}>
                              <div
                                style={{ cursor: "pointer" }}
                                className="bedroom justify-content-start gap-1  "
                              >
                                <img src={linked} alt="" />
                                <span className="d-flex gap-2 justify-content-between align-items-start w-100">
                                  <p onClick={() => handleItemClick(item)}>
                                    {item.class}
                                  </p>
                                  {/* <img src="/assets/icons/delete.svg" alt="" /> */}
                                  <img
                                    src={add}
                                    alt=""
                                    onClick={() =>
                                      setShowValues((prevIndex) =>
                                        prevIndex === index ? null : index
                                      )
                                    }
                                  />
                                </span>
                              </div>
                              {/* {console.log(showValues)} */}
                              {showValues === index && (
                                <div className="bedroom-dropdown px-3   text-white   ">
                                  <ul className="ps-3 border-top py-3">
                                    <li className="d-flex gap-1">
                                      <img
                                        src={linked}
                                        alt=""
                                        style={{ width: "20px" }}
                                      />
                                      1 Light
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          );
                        }
                        return null;
                      })}
                </div>
                <div className="buttons validate-items">
                  <div className="validate">
                    <button onClick={validateItems}>Validate Items</button>
                    <button onClick={handleClick}>Populate new items</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Basic Modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        className="add-space-modal"
      >
        <div className="inner-content">
          <div className="head">
            <h4 className="fw-medium text-center">Add space</h4>
          </div>
          <div className="dropdown">
            <Dropdown
              menu={{
                items,
              }}
              trigger={["click"]}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  Select space
                  <DownOutlined />
                </Space>
              </a>
            </Dropdown>
          </div>
          <input type="text" name="" id="" placeholder="Enter the name" />
          <button>Save</button>
        </div>
      </Modal>
    </div>
  );
};

export default ScannedStatus;
